import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    //baseURL: "https://wcqiplataforma.herokuapp.com/"
    //baseURL: "http://localhost:8080/"
});

const apiKey = (process.env.REACT_APP_API_KEY || '').trim();
api.defaults.headers.common['X-API-Key'] = apiKey;

export default api;